<template>
  <div class="property-index-container">
    <div class="vc-index-nav">
      <span><i class="el-icon-s-home margin-right-sm"></i>{{ $t('propertyIndex.home') }}</span>
      <span class="margin-left-sm margin-right-sm">/</span>
      <span>{{ $t('propertyIndex.dashboard') }}</span>
    </div>

    <div class="vc-index-row">
      <index-community ref="indexCommunity" />
    </div>

    <div class="vc-index-row">
      <index-fee-summary ref="indexFeeSummary" />
    </div>

    <el-row class="vc-index-row" :gutter="20">
      <el-col :span="15">
        <index-repair-complaint ref="indexRepairComplaint" />
      </el-col>
      <el-col :span="9">
        <index-owner-room ref="indexOwnerRoom" />
      </el-col>
    </el-row>

    <div class="vc-index-row">
      <index-notice ref="indexNotice" />
    </div>
  </div>
</template>

<script>
import IndexCommunity from '@/components/index/indexCommunity'
import IndexFeeSummary from '@/components/index/indexFeeSummary'
import IndexRepairComplaint from '@/components/index/indexRepairComplaint'
import IndexOwnerRoom from '@/components/index/indexOwnerRoom'
import IndexNotice from '@/components/index/indexNotice'

export default {
  name: 'PropertyIndexList',
  components: {
    IndexCommunity,
    IndexFeeSummary,
    IndexRepairComplaint,
    IndexOwnerRoom,
    IndexNotice
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.$refs.indexCommunity._loadPropertyIndexAssets()
      this.$refs.indexFeeSummary._loadFeeIndexData()
      this.$refs.indexRepairComplaint.initData()
      this.$refs.indexOwnerRoom._loadIndexOwnerRegisterData()
      this.$refs.indexNotice._loadPropertyIndexNotices()
    }
  }
}
</script>

<style lang="scss" scoped>
.property-index-container {
  padding: 0 10px;

  .vc-index-nav {
    padding: 10px;
    font-size: 16px;
    text-align: left;
  }

  .margin-right-sm {
    margin-right: 5px;
  }

  .margin-left-sm {
    margin-left: 5px;
  }

  .vc-index-row {
    margin-bottom: 20px;
  }
}
</style>